import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getSISContract } from '~/contracts/getSISContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { CONFIG } from '~/lib/config'

const VESIS_CONIFG = CONFIG.vesis[0]

export function useGetTestSIS() {
	const { web3, account } = useWallet()

	const queryClient = useQueryClient()

	const { data, isLoading } = useQuery(
		sisTokenKeys.availableToClaim(VESIS_CONIFG.chain.id, account),
		() => {
			const contract = getSISContract(VESIS_CONIFG, web3)

			return contract.availableToClaim(account)
		},
		{
			enabled: !!account,
		}
	)

	const { isLoading: isReceiving, mutate } = useMutation(
		async () => {
			const contract = getSISContract(VESIS_CONIFG, web3).connect(
				web3.getSigner(account)
			)

			const tx = await contract.claim(account)

			await tx.wait()
		},
		{
			onSuccess() {
				queryClient.resetQueries(
					sisTokenKeys.balance(VESIS_CONIFG.chain.id, account)
				)
				queryClient.resetQueries(
					sisTokenKeys.availableToClaim(
						VESIS_CONIFG.chain.id,
						account
					)
				)
			},
		}
	)

	const isAvailable = !isLoading && data

	return {
		getTestSIS: mutate,
		isReceiving,
		isAvailable,
	}
}
